var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-main"},[_c('nav-bar'),_c('section',{staticClass:"add-address-main"},[_c('div',{staticClass:"review-container review-main text-capitalize position-relative new-addrd"},[_c('AddAddress')],1)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }